var module = angular.module('meternet.report.services', [
	'meternet.stomp.services',
	'meternet.energyReport.services'
]);
